import moment from "moment";

class MetricManager {
  constructor(data) {
    this.data = data;
    this.dependent_level = this.data.spending_account.dependent_level
    this.start_date = this.getStartDate(this.data);
    this.end_date = this.getEndDate(this.data);
    this.utilized_employees_count = this.getEmployeesCount(this.data)
    this.utilized_dependent_count = this.getFamilyCount(this.data)
    this.employee_per_count = this.getPerEmployeeAmount(this.data)
    this.utilized_employees_amount = this.getEmployeesAmount(this.data)
    this.utilized_dependent_amount = this.getFamilyAmount(this.data)
    this.total_customers_amount = this.totalCustomerAmount(this.data);
    this.utilized_amount_utilization = this.utilizedAmountUtilization(this.data)
    this.SA_Completed = this.SA_Completed(this.data);
    this.notCompletedSA = this.customersNotCompletedSA(this.data);
    this.donutData = this.donutGraphData();
    this.avg_utilization_amount = this.AvgUtilizationAmount(this.data)
    this.partners = this.partners()
  }

  getStartDate (data){
  const date = moment(data.spending_account.start_date).format('DD MMM YY')
    return date
  }

  getEndDate (data){
    const date = moment(data.spending_account.end_date).format('DD MMM YY')
    return date
  }

  getEmployeesCount(data) {
    return data.employee.utilized_employees_count
  }

  getFamilyCount(data) {
      return data.dependent.utilized_dependent_count
  }


  getEmployeesAmount(data) {
    return data.employee.utilized_amount
  }

  getFamilyAmount(data) {
      return data.dependent.utilized_amount
  }

  getPerEmployeeAmount(data) {
    return data.spending_account.initial_balance
  }

  apiResponse() {
    return this.data;
  }

  customersNotCompletedSA(data) {
    return data.utilization.total_amount - data.utilization.utilized_amount;
  }


  totalCustomerAmount(data) {
    return data.utilization.total_amount;
  }

  utilizedAmountUtilization(data) {
      return data.utilization.utilized_amount
  }
  
  AvgUtilizationAmount(data) {
    return data.utilization.avg_utilization_amount
  }

  SA_Completed() {
    return this.floorPercentage(this.utilized_amount_utilization, this.total_customers_amount);
  }

  floorPercentage(numerator, denominator) {
    if(denominator === 0  || numerator === 0) {
      return 0
    }
    return Math.round((numerator / denominator) * 100);
  }

  donutGraphData() {
    let result = [];
    if (this.data.utilization.utilized_amount) {
      result.push({
        number: this.data.utilization.utilized_amount,
        percentage: this.SA_Completed,
        color: '#5A8BED',
      });
      result.push({
        number: this.notCompletedSA,
        percentage: (100 - this.SA_Completed),
        color: '#E5E8F0',
      });
    }
    return result;
  }

  partners(data){
    return this.data.providers.map((item, key) => ({
      id:key,
      partner_name: item[0],
      employee_count: item[1],
    }));
  }
}

export default MetricManager;
